import { ActionIcon, Group } from '@mantine/core';

import { Icon } from 'components/Icon/IconDeprecated';
import { Text } from 'components/Text/Text';

export type CursorPaginationProps = {
  page: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
  disabled?: boolean;
  className?: string;
};

export function CursorPagination({
  page,
  hasNextPage,
  hasPreviousPage,
  onNextPage,
  onPreviousPage,
  disabled,
  className,
}: CursorPaginationProps) {
  if (!hasNextPage && !hasPreviousPage) {
    return null;
  }

  return (
    <Group gap="sm" py="xs" className={className}>
      <ActionIcon
        aria-label="Previous page"
        variant="default"
        size="md"
        radius="md"
        onClick={onPreviousPage}
        disabled={!hasPreviousPage || disabled}
      >
        <Icon name="chevron-left" size="small" unstyled />
      </ActionIcon>
      <Text size="xsmall">Page {page}</Text>
      <ActionIcon
        aria-label="Next page"
        variant="default"
        size="md"
        radius="md"
        onClick={onNextPage}
        disabled={!hasNextPage || disabled}
      >
        <Icon name="chevron-right" size="small" unstyled />
      </ActionIcon>
    </Group>
  );
}
